var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorldIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.08331C6.75 2.08331 2.08333 6.74998 2.08333 12.5C2.08333 18.25 6.75 22.9166 12.5 22.9166C18.25 22.9166 22.9167 18.25 22.9167 12.5C22.9167 6.74998 18.25 2.08331 12.5 2.08331ZM11.4583 20.7604C7.34375 20.25 4.16667 16.75 4.16667 12.5C4.16667 11.8541 4.25 11.2396 4.38542 10.6354L9.375 15.625V16.6666C9.375 17.8125 10.3125 18.75 11.4583 18.75V20.7604ZM18.6458 18.1146C18.375 17.2708 17.6042 16.6666 16.6667 16.6666H15.625V13.5416C15.625 12.9687 15.1562 12.5 14.5833 12.5H8.33333V10.4166H10.4167C10.9896 10.4166 11.4583 9.9479 11.4583 9.37498V7.29165H13.5417C14.6875 7.29165 15.625 6.35415 15.625 5.20831V4.78123C18.6771 6.02081 20.8333 9.0104 20.8333 12.5C20.8333 14.6666 20 16.6354 18.6458 18.1146Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldIcon);
export default __webpack_public_path__ + "static/media/world-icon.3f0e75e2a194e67e28743b313622cc38.svg";
export { ForwardRef as ReactComponent };